import { render, staticRenderFns } from "./breakpoint.vue?vue&type=template&id=88871cce&scoped=true&"
import script from "./breakpoint.vue?vue&type=script&lang=js&"
export * from "./breakpoint.vue?vue&type=script&lang=js&"
import style0 from "./breakpoint.vue?vue&type=style&index=0&id=88871cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88871cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88871cce')) {
      api.createRecord('88871cce', component.options)
    } else {
      api.reload('88871cce', component.options)
    }
    module.hot.accept("./breakpoint.vue?vue&type=template&id=88871cce&scoped=true&", function () {
      api.rerender('88871cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/example/breakpoint/breakpoint.vue"
export default component.exports